import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks";
import {
  buildVocabularyVariables,
  VocabularyVariables,
} from "../../organization/utils/vocabularyVariables";
import { selectPortalMe } from "../portal-slice";

/**
 * The portal's twin of `useVocabulary()`: the signed-in member's organization
 * words (from `portal/me`) for the active UI language. The instructor app's
 * organization is never loaded in the portal, so portal components use this.
 * The Default preset applies until `portal/me` has loaded.
 */
export const usePortalVocabulary = (): VocabularyVariables => {
  const { i18n } = useTranslation();
  const vocabulary = useAppSelector(selectPortalMe)?.organization.vocabulary ?? null;
  const language = i18n.language;
  return useMemo(() => buildVocabularyVariables(vocabulary, language), [vocabulary, language]);
};
